<span [ngClass]="baseStyles + ' ' + sizeClass + ' ' + colorStyles">
  @if (startIcon) {
    <span class="mr-1"><i [class]="startIconClass" aria-hidden="true"></i></span>
  }
  <ng-content></ng-content>
  @if (endIcon) {
    <span class="ml-1"><i [class]="endIconClass" aria-hidden="true"></i></span>
  }
</span>